import type {DocNode} from '../types/docset';

export type NodeIndex = {
  byPath: Map<string, DocNode>;
  bySlug: Map<string, DocNode>;
};

export function buildNodeIndex(nodes: DocNode[]): NodeIndex {
  const byPath = new Map<string, DocNode>();
  const bySlug = new Map<string, DocNode>();

  const walk = (node: DocNode) => {
    const pathKey = node.pathSegments.join('/');
    byPath.set(pathKey, node);
    bySlug.set(node.slug, node);
    node.children.forEach(walk);
  };

  nodes.forEach(walk);

  return {byPath, bySlug};
}

